import React, { useEffect } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

// services
import { showMessage } from "../../services/message.js";

// api
import { api_GET } from "../../services/api_service.js";

//Context
import { useAuth } from "../../context/auth";

export default function ManutencaoForm({ history }) {
  const { session } = useAuth();

  const [opcoes, set_opcoes] = React.useState([]);

  const LoadOpcoes = () => {
    api_GET(
      `categoria/GetListByExistsSetupSolicitacaoByUsuario/${session.usuario_Id}`
    )
      .then((result) => set_opcoes(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  };

  useEffect(() => {
    LoadOpcoes();
  }, []);

  const handleClickOpcao = (opcao) => {
    let _setupSolicitacao = [];
    let _tipoPessoa = {
      Física: "Pessoa Física",
      Jurídica: "Pessoa Jurídica (Privada)",
      ["Jurídica - MEI"]: "Pessoa Jurídica (MEI)",
      Pública: "Pessoa Jurídica (Pública)",
    };
    _setupSolicitacao = opcao.setupSolicitacoes.map(
      ({ setupSolicitacao_Id, pessoa }) => {
        return {
          setupSolicitacao_Id,
          value: pessoa,
          label: _tipoPessoa[pessoa],
        };
      }
    );
    switch (opcao.segmento) {
      case "Transportador":
        history.push({
          pathname: "manutencaotransportador",
          state: { categoria: opcao },
        });
        break;
      case "Grande Gerador":
        if (opcao.sigla === "RSS")
          history.push({
            pathname: "manutencaogeradorrss",
            state: { categoria: opcao, setupSolicitacao: _setupSolicitacao },
          });
        else
          history.push({
            pathname: "manutencaogerador",
            state: { categoria: opcao },
          });
        break;
      case "Grande Gerador - PGRCC":
        history.push({
          pathname: "manutencaogeradorpgrcc",
          state: { categoria: opcao, setupSolicitacao: _setupSolicitacao },
        });
        break;
      case "Destino Final":
        history.push({
          pathname: "manutencaodestino",
          state: { categoria: opcao },
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          {opcoes.map((m, key) => (
            <Col lg="4" md="6" sm="6" key={key}>
              <Card className="card-stats">
                <CardHeader className="text-center titulo-card">
                  {m.descricao.includes("RSS")
                    ? m.segmento.replace("Grande", "")
                    : m.segmento}
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="12" xs="12" className="text-center mb-4">
                      <strong>{m.descricao}</strong>
                      <div
                        className="icon-lg text-center icon-info card-box"
                        onClick={() => handleClickOpcao(m)}
                      >
                        <i class={m.classeIcone + " " + m.corIcone}></i>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}
